import { useEffectOnce } from 'react-use';

import { parseTokenFromQueryParams } from '../utils/parseTokenFromQueryParams';
import { setReserveWithGoogleToken } from '../utils/setReserveWithGoogleToken';

export const useReserveWithGoogle = () =>
  useEffectOnce(() => {
    const rwgToken = parseTokenFromQueryParams();
    setReserveWithGoogleToken(rwgToken);
  });
